import React from 'react';
import {AssetExpirationProvider} from '../contexts';

/**
 * Wraps a component in the AssetExpirationProvider
 * @example
	const WrappedComponent = withAssetExpiration(Componenet);
 */
export const withAssetExpiration = function <C extends React.ElementType>(
	Component: C,
) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<AssetExpirationProvider>
				<Component {...props} />
			</AssetExpirationProvider>
		);
	};
};
